import React from 'react';

export default function StatsCard({ title, value }) {
  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h3 className="text-gray-500 text-sm font-medium">{title}</h3>
      <div className="mt-2">
        <p className="text-3xl font-semibold text-gray-900">{value}</p>
      </div>
    </div>
  );
}
